import { useState, useContext } from "react";
import "./ApplicationForStaff.scss";
import { LuUpload } from "react-icons/lu";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import Header from "../../../Shared-Component/Header/Header";
import Footer from "../../../Shared-Component/Footer/Footer";
import CampusSlashTitle from "../../../CampusLife/CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle";
import { useRef } from "react";
import { BsDownload } from "react-icons/bs";
import { Link } from "react-router-dom";
import axios from 'axios';
import { AppContext } from "../../../context/AppContext";
import { toast } from 'react-toastify';
import SuccessDialog from "../../../components/SuccessDialog.jsx";

const ApplicationForStaff = () => {

  const { backendUrl } = useContext(AppContext)
  const fileInputRef = useRef(null);
  const eMailpattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  const phoneNumberPattern = /^\+[\d]{1,3}[-\s]?[\d]{6,14}$/
  const [applicationStaffFormData, setapplicationStaffFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    applyingRole: ""
  });
  const [fileName, setFileName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [errors, setErrors] = useState({})
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.type !== "application/pdf") {
      setErrors((prev) => ({
        ...prev,
        resume: "Only PDF files are allowed",
      }));
      fileInputRef.current.value = "";
      return;
    }

    setFileName(selectedFile?.name || "");
    setErrors((prev) => ({
      ...prev,
      resume: "",
    }));
  };
  const handleChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    setapplicationStaffFormData({ ...applicationStaffFormData, [name]: value })

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ""
    }));
  }

  const validateForm = () => {
    const file = fileInputRef.current?.files[0];
    const testeMailpattern = eMailpattern.test(applicationStaffFormData.email);
    const testphoneNumberPattern = phoneNumberPattern.test(applicationStaffFormData.phoneNumber);
    const error = {};


    setErrors({});

    if (!file) {
      error.resume = "Please select the resume";
    } else if (file.type !== "application/pdf") {
      error.resume = "Only PDF files are allowed";
    }

    if (!applicationStaffFormData.name.trim()) {
      error.name = "Required";
    }

    if (!applicationStaffFormData.phoneNumber.trim()) {
      error.phoneNumber = "Required";
    } else if (!testphoneNumberPattern) {
      error.phoneNumber = "Invalid phone number";
    }

    if (!applicationStaffFormData.email.trim()) {
      error.email = "Required";
    } else if (!testeMailpattern) {
      error.email = "Invalid Email";
    }

    if (!applicationStaffFormData.applyingRole.trim()) {
      error.applyingRole = "Required";
    }

    setErrors(error);

    // Return true if no errors, false if there are errors
    return Object.keys(error).length === 0;
  }
  const clearForm = () => {
    setapplicationStaffFormData({
      name: "",
      phoneNumber: "",
      email: "",
      applyingRole: ""
    })
    fileInputRef.current.value = null;
    setFileName("")
    setErrors({})
  }
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form first - if validation fails, return early
    if (!validateForm()) {
      console.log('Form validation failed');
      return; // Stop execution if validation fails
    }

    setIsSubmitting(true);
    const file = fileInputRef.current?.files[0];

    try {
      console.log('Submitting staff application data:', applicationStaffFormData);
      console.log('Selected file:', file);

      const formData = new FormData();
      formData.append("resume", file);
      Object.entries(applicationStaffFormData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const res = await axios.post(`${backendUrl}/api/auth/submitStaffApplication`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('Response:', res.data);

      if (res.data.success === true) {
        setShowSuccessDialog(true);
        clearForm();
      }
    }
    catch (error) {
      console.error('Full error:', error);
      console.error('Error response:', error.response);

      if (error.response) {
        console.error('Error status:', error.response.status);
        console.error('Error data:', error.response.data);

        if (error.response.status === 503) {
          toast.error("⚠️ The service is currently under maintenance. Please try again later.");
        }
        else if (error.response.status === 500) {
          const serverMessage = error.response.data?.message || 'Internal Server Error';
          toast.error(`Server Error: ${serverMessage}`);
          console.error('Server error details:', error.response.data);
        }
        else if (error.response.status === 400) {
          toast.error(error.response.data?.message || 'Validation error');
        }
      }
      else if (!navigator.onLine) {
        toast.error("🚫 No internet connection. Please check your network.");
      }
      else if (error.request && !error.response) {
        toast.error("⚠️ Network issue or server is unreachable. Try again later.")
      }
      else {
        console.error("Unexpected error:", error);
        toast.error("Something went wrong.");
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="staffApplicationMainContainer">

      <SuccessDialog
        visible={showSuccessDialog}
        onHide={() => setShowSuccessDialog(false)}
        header="Application Submitted"
        message="Your application for staff has been submitted successfully!"
        buttonLabel="OK"
      />

      <div>
        <Header />
        <div className="campusmaincontainer">
          <div className="campus-container">
            <CampusSlashTitle slashTitle="Application For Staff" />
            <div className="ASSInfo-container">
              <div className="ASSInfo-subcontainer">
                <div className="ASSInfo-formcontainer">
                  <div className="ASSresume-container">
                    <div className={errors.resume ? "ASSresumeError" : "ASSresume"} onClick={handleButtonClick}>
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <Button
                        icon={<LuUpload className="ASSuploadicon" />}
                        className="p-button-primary"
                      />
                      <p>Upload Your Resume</p>
                      {
                        fileName && <p style={{ fontSize: "18px", }}>{fileName}</p>
                      }

                    </div>
                    {
                      errors.resume &&
                      <p style={{ color: 'red', fontSize: '14px' }}>{errors.resume}</p>
                    }
                    <div style={{ display: "block", margin: "auto" }}>

                      <div className="ASS-fromdownloadcontainer">
                        <Link style={{ textDecoration: "none" }} onClick={() => window.open("/TeachingStaffApplicationForm.pdf", "_blank")}><div className='formdownload-subcontainer' >
                          <div><BsDownload className='ASSformdownload-icon' /></div>
                          <div><p className='ASSformdownload-label'>Application Form For Teaching Staff</p></div>
                        </div></Link>
                        <Link style={{ textDecoration: "none" }} onClick={() => window.open("/NonteachingStaffApplicationForm.pdf", "_blank")}> <div className='formdownload-subcontainer' >
                          <div><BsDownload className='ASSformdownload-icon' /></div>
                          <div><p className='ASSformdownload-label'>Application Form For Non-Teaching Staff</p></div>
                        </div></Link>

                      </div>
                    </div>
                  </div>
                  <div className="ASSform-container">
                    <form>
                      <div className="ASSform">
                        <div className="ASSform-subcontainer">
                          <label>Name</label>
                          <InputText
                            className="ASSforminput"
                            placeholder="Enter your name"
                            name="name"
                            value={applicationStaffFormData.name}
                            onChange={handleChange}
                            invalid={!!errors.name}
                          />
                          {
                            errors.name &&
                            <p style={{ color: 'rgb(248, 48, 48)', fontSize: '14px' }} >{errors.name}</p>
                          }
                        </div>
                        <div className="ASSform-subcontainer">
                          <label>Phone Number</label>
                          <InputText
                            className="ASSforminput"
                            placeholder="+91 0000000000"
                            name="phoneNumber"
                            value={applicationStaffFormData.phoneNumber}
                            onChange={handleChange}
                            invalid={!!errors.name}
                          />
                          {
                            errors.phoneNumber &&
                            <p style={{ color: 'rgb(248, 48, 48)', fontSize: '14px' }} >{errors.phoneNumber}</p>
                          }
                        </div>
                        <div className="ASSform-subcontainer">
                          <label>E-mail</label>
                          <InputText
                            className="ASSforminput"
                            placeholder="Enter your e-mail"
                            name="email"
                            value={applicationStaffFormData.email}
                            onChange={handleChange}
                            invalid={!!errors.email}
                          />
                          {
                            errors.email &&
                            <p style={{ color: 'rgb(248, 48, 48)', fontSize: '14px' }} >{errors.email}</p>
                          }
                        </div>
                        <div className="ASSform-subcontainer">
                          <label>Applying for</label>
                          <InputText
                            className="ASSforminput"
                            placeholder="Applying for"
                            name="applyingRole"
                            value={applicationStaffFormData.applyingRole}
                            onChange={handleChange}
                            invalid={!!errors.applyingRole}
                          />
                          {
                            errors.applyingRole &&
                            <p style={{ color: 'rgb(248, 48, 48)', fontSize: '14px' }} >{errors.applyingRole}</p>
                          }
                        </div>
                      </div>
                      <div className="ASSbutton">
                        <Button
                          className="ASSsubmit"
                          label={isSubmitting ? "Submitting..." : "Submit"}
                          icon={isSubmitting ? "pi pi-spin pi-spinner" : null}
                          disabled={isSubmitting}
                          onClick={handleSubmit}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default ApplicationForStaff;
